const GUEST_CART_KEY = 'guest_cart';

export const getGuestCart = () => {
  try {
    const cart = localStorage.getItem(GUEST_CART_KEY);

    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error('Error getting guest cart:', error);
    return [];
  }
};

export const addToGuestCart = (course) => {
  const cart = getGuestCart();

  const alreadyInCart = cart.some((item) => item.courseId === course._id);

  if (alreadyInCart) {
    return cart;
  }

  const updatedCart = [
    ...cart,
    {
      courseId: course._id,
      title: course.title,
      price: course.price,
      image: course.image,
      expiryDate: course.expiryDate,
      partTwo: course.partTwo,
      part2Price: course.part2Price,
      quantity: course.quantity || 1,
    },
  ];

  localStorage.setItem(GUEST_CART_KEY, JSON.stringify(updatedCart));

  // Ensure a temporary id exists so other providers (which look for temp_id)
  // can operate consistently for guests.
  if (!localStorage.getItem('temp_id')) {
    try {
      const tempId = `guest_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
      localStorage.setItem('temp_id', tempId);
    } catch (err) {
      // ignore storage errors
    }
  }

  // Notify listeners (CartDataProvider) that the guest cart updated
  try {
    window.dispatchEvent(new Event('guest-cart-updated'));
  } catch (err) {
    /* ignore */
  }

  return updatedCart;
};

export const removeFromGuestCart = (courseId) => {
  const cart = getGuestCart();

  const updatedCart = cart.filter((item) => item.courseId !== courseId);

  localStorage.setItem(GUEST_CART_KEY, JSON.stringify(updatedCart));

  // Notify listeners that guest cart changed
  try {
    window.dispatchEvent(new Event('guest-cart-updated'));
  } catch (err) {
    /* ignore */
  }

  return updatedCart;
};

export const clearGuestCart = () => {
  localStorage.removeItem(GUEST_CART_KEY);
  try {
    window.dispatchEvent(new Event('guest-cart-updated'));
  } catch (err) {
    /* ignore */
  }
};
